import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Modal, Row, Col, Alert, Spinner } from 'react-bootstrap';
import PlanService from '../../service/PlanService';
import EmailService from '../../service/EmailService';
import SlimAd from '../../assets/diamond-slim-ad.webp';

const Plans = () => {
  const [plans, setPlans] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', formMessage: '' });
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await PlanService.getAllPlans();
      setPlans(response);
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };

  const handleShow = (plan) => {
    setSelectedPlan(plan);
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', variant: '' });

    try {
      const response = await EmailService.sendEmail(formData);
      setMessage({ text: [response], variant: 'success' });
      setFormData({ name: '', email: '', phone: '', formMessage: '' });
    } catch (error) {
      setMessage({ text: `Error: ${error.message}`, variant: 'danger' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => setShowModal(false);

  return (
    <>
      <section className="plan-section">
        <Container>
          <Row>
            <div className="plan_title">
              <h2 className="text-center">Browse Through Our Plans</h2>
              <p className="text-center">
                Select the plan that aligns with your needs, available in both monthly and <br />yearly subscription formats.
              </p>
            </div>
          </Row>

          {/* Directly render the plan content without tabs */}
          <Row className="mt-3 plan_content justify-content-center">
            {plans.map((plan) => (
              <Col lg={10} md={11} className="mb-4 px-3 px-md-0" key={plan.id}>
                <Card className="text-start border-blk">
                  <Row className="mx-0">
                    <Col className='px-0 order-md-1 order-2' md={plan.imageName ? 9 : 12}>
                      <Card.Body className='planCard-style h-100 position-relative pb-0 pt-2 d-flex flex-column'>
                        <Row className="flex-grow-1">

                          <div className='col-md-12'>
                            <div className='row justify-content-between align-items-center'>
                              <div className='cardText col-md-5 col-lg-6 col-12'>
                                <Card.Title>Your Company Name</Card.Title>
                              </div>

                              <div className='cardText col-md-5 col-lg-4 col-8'>
                                <h6 className='ad_worktype'>Work Type : <b>Shop/Mobile</b></h6>
                              </div>

                              <div className='cardText col-md-2 col-4 text-right'>
                                <span className='ad_miles'>0.0 Miles</span>
                              </div>
                            </div>
                          </div>


                          <div className='col-md-12'>
                            <div className='cardText'>
                              <p className='ad_address mb-0'><i className="fas fa-location-dot" title="location"></i> Address, city, state</p>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className='cardText d-md-flex gap-3'>
                              <p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> contact@demo.com</p>
                              <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                                <a href="#" rel="noopener noreferrer"> www.demo.com</a>
                              </p>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className='ad_services'>
                              <ul className='ad_serviceList'>
                                <li>Road Service</li>
                                <li>Electrical System</li>
                                <li>New Tires Sales</li>
                                <li>Fleet Acounts</li>
                              </ul>
                            </div>
                          </div>

                          <div className='col-md-12'>
                            <div className="ad_description">
                              <p>{plan.description}</p>
                            </div>
                          </div>
                        </Row>

                        <div className='row align-items-center mt-md-auto plan_actions_column'>
                          <div className='new-ad-bottom col-md-4 order-2 order-md-1'>
                            <div className='bd_plan_contact text-center'>
                              <button className='btn mb-0 py-1' type="button"><i className="fa fa-phone" title="phone"></i> (800) 805-7820</button>
                            </div>
                          </div>

                          <div className='col-md-4 order-1 order-md-2 border-left border-right py-md-2 py-3'>
                            <div className='home_plan_price text-center'>
                              {/* <h5>{plan.name} </h5>  */}
                              <h3><sup>$</sup>{plan.price}<span> / Per Month</span></h3>
                            </div>
                          </div>

                          <div className='col-md-4 order-3 order-md-3'>
                            <div className="planPrice-style">
                              <Button className='planBtn shine position-relative' variant="primary" onClick={() => handleShow(plan)}>Get {plan.name}</Button>
                            </div>
                          </div>
                        </div>

                      </Card.Body>
                    </Col>

                    {plan.imageName && (
                      <Col md={3} className="p-0 align-content-around ad_banner order-md-2 order-1">
                        <Card.Img variant="top" className='p-md-2 p-0' src={plan.imageName} alt={plan.name} />
                      </Col>
                    )}
                  </Row>

                </Card>
              </Col>
            ))}
          </Row>

          {/* Modal for contact details */}
          <Modal className="quote_modal" show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Get A Quote</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedPlan && (
                <>
                  <div className="form_content">
                    <p className="mb-4">
                      Thank you for your interest in our <b>{selectedPlan.name} plan</b>. We’re thrilled to offer you our exceptional
                      services and are here to help you every step of the way!
                    </p>
                  </div>

                  <div className="quote_form">
                    <form onSubmit={handleSubmit}>
                      <Row>
                        <div className="col-md-6">
                          <div className="form-group cont_form">
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              placeholder="Your Name"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group cont_form">
                            <input
                              type="tel"
                              className="form-control"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Phone"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group cont_form">
                            <input
                              type="email"
                              className="form-control"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Email"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group cont_form">
                            <textarea
                              className="form-control h-auto"
                              rows="3"
                              cols="50"
                              name="formMessage"
                              value={formData.formMessage}
                              onChange={handleChange}
                              placeholder="Write a message"
                              required
                              disabled={loading}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          {message.text && (
                            <Alert variant={message.variant} className="mt-0 py-2 text-center">
                              {message.text}
                            </Alert>
                          )}
                          <div className="form_btn mt-1">
                            <button type="submit" className="btn w-100" disabled={loading}>
                              {loading ? (
                                <>
                                  <Spinner animation="border" size="sm" role="status" className="me-2" />
                                  Sending...
                                </>
                              ) : (
                                'Submit'
                              )}
                            </button>
                          </div>
                        </div>
                      </Row>
                    </form>
                  </div>
                </>
              )}
            </Modal.Body>
          </Modal>
        </Container>
      </section>
    </>
  );
};

export default Plans;
